import type { TReduxActions } from '../../types/redux';

const PUIDS_RESPONSE = 'countryside-adfox/PUIDS_RESPONSE';

export type AdfoxState = {
  puids: object;
};

const initialState: AdfoxState = {
  puids: {},
};

export function countrysideAdfoxReducer(state = initialState, action: TReduxActions): AdfoxState {
  switch (action.type) {
    case PUIDS_RESPONSE:
      return {
        ...state,
        puids: action.payload,
      };

    default:
      return state;
  }
}

export interface ICountrysideAdfoxPuidsAction {
  type: typeof PUIDS_RESPONSE;
  payload: object;
}

export function setCountrysideAdfoxPuids(puids: object): ICountrysideAdfoxPuidsAction {
  return {
    type: PUIDS_RESPONSE,
    payload: puids,
  };
}
